import { paymentSupportedServiceIds } from '../actions/config.common';

/**
 * Check if service_id supports payment info output
 * @param {number} serviceId
 * @returns {boolean}
 */
export const hasPaymentSupport = (serviceId) => {
  return paymentSupportedServiceIds.indexOf(serviceId) > -1;
};
